<script lang="ts" setup>
import ArrowDropdownIcon from '~/assets/icons/arrows/16/arrowhead-down-black.svg'
import {
  onAccordionTransitionEnter,
  onAccordionTransitionLeave,
  onAccordionAfterEnter,
} from '~/components/ui/accordion/accordion-script'

const props = defineProps<{
  watchMoreIsVisible: boolean
  watchMoreBtnText: {
    closed?: string
    open: string
  }
  withoutArrow?: boolean
  buttonMargin?: string
}>()

const emits = defineEmits(['toggle-accordion'])

const isContainerOpen = ref(false)

const moreOffersText = computed(() => {
  if (isContainerOpen.value) {
    return props.watchMoreBtnText.closed ?? 'Свернуть'
  } else {
    return props.watchMoreBtnText.open
  }
})

function setContainerOpenStatus() {
  isContainerOpen.value = !isContainerOpen.value
  emits('toggle-accordion', isContainerOpen.value)
}
</script>

<template>
  <div class="accordion-list">
    <slot name="initialContent" />
    <Transition
      name="accordion-item"
      @enter="onAccordionTransitionEnter"
      @leave="onAccordionTransitionLeave"
      @after-enter="onAccordionAfterEnter"
    >
      <div v-show="isContainerOpen" class="accordion-hidden__wrapper">
        <slot name="hiddenContent" />
      </div>
    </Transition>
  </div>

  <div
    class="watch-more"
    :class="[isContainerOpen && 'active', buttonMargin && 'withMargin']"
    v-if="watchMoreIsVisible"
    @click="setContainerOpenStatus"
  >
    <span>{{ moreOffersText }}</span>
    <ArrowDropdownIcon v-if="!withoutArrow" />
  </div>
</template>

<style lang="scss" scoped>
.watch-more {
  border: 1px solid $control-bg_neutral;
  background-color: $control-bg_neutral;
  border-radius: 8px;
  @include font(14px, 20px, 500);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 0;
  transition: 0.3s background-color;
  z-index: 1;
  position: relative;
  cursor: pointer;
  @include md-breakpoint {
    background-color: $control-bg_white;
    border-color: $control-border_grey;
    margin-top: 12px;
  }

  &:hover:not(:active) {
    @include mf-breakpoint {
      background-color: $control-bg_neutral-hover;
    }
  }

  svg {
    transition: transform 0.3s;
  }

  &.withMargin {
    margin-top: v-bind(buttonMargin);
  }

  &.active {
    svg {
      transform: rotate(180deg);
    }
  }
}
.accordion-content__wrapper {
  @include md-breakpoint {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  :deep(.search__table-cell:nth-child(2)) {
    @include md-breakpoint {
      margin: 0;
    }
  }
}
</style>
